import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const ProductVariantBySelectedOptions_Query = graphqlShopifyStorefront(
  `
  query ProductVariantBySelectedOptions(
    $country: CountryCode
    $handle: String!
    $language: LanguageCode
    $selectedOptions: [SelectedOptionInput!]!
  ) @inContext(country: $country, language: $language) {
    product(handle: $handle) {
      productType
      variantBySelectedOptionsMasked: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        ...ProductVariant
      }
    }
  }
`,
  // [ProductVariant_Fragment],
);
